import { useContext, useEffect, useState } from "react";
import {
    Modal,
    Descriptions,
    Tag,
    Image,
    Button,
    Input,
    DatePicker,
    Space,
    Select
} from "antd";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import axios from "axios";
import { AuthContext } from "../../context/AuthContext";

const { Option } = Select;


export default function OverallReviewModal({ visible, employee, onClose }) {
    const [remarks, setRemarks] = useState("");
    const { authData, backUrl } = useContext(AuthContext);
    const [approver, setApprover] = useState(null);
    const [days, setDays] = useState(null);
    const [loading, setLoading] = useState(false);


    // ✅ Fetch approver info from employee.approval_steps
    useEffect(() => {
        if (employee?.approval_steps && Array.isArray(employee.approval_steps)) {
            const activeApprover = employee.approval_steps.filter(
                (step) => step.status === "PENDING" || step.status === "IN_PROGRESS"
            );

            if (activeApprover.length > 0) {
                setApprover(activeApprover);
            } else {
                // fallback: pick last approver or null
                setApprover(employee.approval_steps.slice(-1));
            }
        } else {
            setApprover(null);
        }
    }, [employee]);


    const handleProceed = async () => {
        if (!remarks.trim() || !days) {
            toast.error("Please enter a reason and select PIP duration.");
            return;
        }

        setLoading(true);

        try {
            const payload = {
                employee: employee.id,
                reason: remarks,
                pip_days: Number(days),
            };

            await axios.post(`${backUrl}/api/piprequest/pip-requests/`, payload, {
                headers: { Authorization: `Bearer ${authData?.access}` },
            });


            toast.success("PIP requests raised successfully!");
            setDays(null);
            setRemarks("");
        } catch (error) {
            console.error("Error raising PIP:", error);

            // ✅ Handle validation error response
            if (error.response && error.response.data) {
                const errData = error.response.data;
                if (errData.reason) {
                    toast.error(errData.reason[0]);
                } else {
                    toast.error("Failed to raise one or more PIP requests.");
                }
            } else {
                toast.error("Network error. Please try again.");
            }
        } finally {
            setLoading(false);
        }
    };





    return (
        <>
            <ToastContainer position="top-right" autoClose={2500} hideProgressBar />

            <Modal
                open={visible}
                title={`Employee Details - ${employee?.user?.username}`}
                onCancel={onClose}
                footer={null}
                width={750}
            >
                {/* ✅ Employee details */}
                <Descriptions bordered column={2} size="small">
                    <Descriptions.Item label="Name">
                        {employee?.first_name}
                    </Descriptions.Item>
                    <Descriptions.Item label="Organisation & Department">
                        {employee?.organisation_name} - {employee?.department_name}
                    </Descriptions.Item>

                    <Descriptions.Item label="Designation">
                        {employee?.designation_name}
                    </Descriptions.Item>
                    <Descriptions.Item label="Date of Birth">
                        {employee?.date_of_birth
                            ? new Date(employee.date_of_birth).toLocaleDateString("en-GB")
                            : "—"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Date Of Joining">
                        {
                            new Date(employee.date_of_joining).toLocaleDateString("en-GB")
                        }
                    </Descriptions.Item>
                    <Descriptions.Item label="Reporting To">
                        {employee?.reporting_to_name || "—"}
                    </Descriptions.Item>

                    <Descriptions.Item label="Status">
                        <Tag
                            color={
                                employee.status === "CONFIRMED"
                                    ? "green"
                                    : employee.status === "IN_PROGRESS"
                                        ? "orange"
                                        : "default"
                            }
                        >
                            {employee.status}
                        </Tag>
                    </Descriptions.Item>

                    <Descriptions.Item label="Photo" span={2}>
                        {employee?.photo ? (
                            <Image
                                src={`http://127.0.0.1:8000${employee.photo}`}
                                alt="Employee Photo"
                                width={120}
                                height={120}
                                style={{ borderRadius: "10px", objectFit: "cover" }}
                            />
                        ) : (
                            <Tag color="default">No Photo</Tag>
                        )}
                    </Descriptions.Item>
                </Descriptions>

                {/* ✅ Remarks and buttons */}
                <div style={{ marginTop: 20 }}>
                    <center>
                        <div style={{ marginBottom: "10px" }}>
                            <Select
                                placeholder="Select PIP Duration"
                                style={{ width: 200 }}
                                value={days}
                                onChange={(value) => setDays(value)}
                                disabled={loading}
                            >
                                <Option value={30}>30 Days</Option>
                                <Option value={60}>60 Days</Option>
                            </Select>
                        </div>
                    </center>
                    <label>
                        <b>Remarks:</b>
                    </label>
                    <Input.TextArea
                        rows={3}
                        placeholder="Enter your remarks here..."
                        value={approver?.[0]?.remarks ? approver[0].remarks : remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        style={{ marginTop: 5 }}
                        disabled={loading}
                    />

                    <center>
                        <Button
                            className="mt-2"
                            style={{ background: '#0e497b', color: 'white' }}
                            onClick={handleProceed}
                            loading={loading}
                            disabled={loading}
                        >
                            Raise PIP
                        </Button>
                    </center>
                </div>
            </Modal>

        </>
    );
}